import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {from, Observable, of} from 'rxjs';
import {concatMap, filter, map, toArray} from 'rxjs/operators';

enum OperationKind {
    REGEX = 0
}

@HookClass('data')
export class DataNormalizeHook extends BaseHook {

    @Hook('822d265b-1ffa-46fd-a324-12f68e2cf589')
    public normalize(input: NickProcessArtfact): Observable<NickProcessArtfact> {

        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = {};

        return from(input.object.operations)
            .pipe(concatMap((operation: any) => {
                switch (operation.kind) {
                    case OperationKind.REGEX: {
                        const ls = Object.keys(input.object.data);
                        return from(ls)
                            .pipe(filter((property: string) => input.object.data[property] != undefined))
                            .pipe(map((property: string) => {
                                if (operation.field == property && input.object.data[property] != undefined) {
                                    if (!input.object.data[property].match)
                                        input.object.data[property] = input.object.data[property].toString();

                                    const result = input.object.data[property].match(new RegExp(operation.regex.expression, operation.regex.type));

                                    if (operation.defaultValue != undefined && !result)
                                        input.object.data[property] = operation.defaultValue;
                                    else
                                        input.object.data[property] = result?.join('');
                                }

                                return input.object.data[property];
                            }), toArray())
                            .pipe(map(() => {
                                outputArtifact.object = input.object.data;
                            }));
                    }
                }
            }), toArray())
            .pipe(map(() => outputArtifact));
    }

    @Hook('20cb8ef6-1c3d-455b-a7ea-2f9758167c15')
    public padLeft(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        input.object.data = input.object.data.toString().padStart(input.object.config.length, input.object.config.character);
        return of(input);
    }

}
